import {
  Component,
  ComponentInterface,
  Fragment,
  h,
  Host,
  Prop,
  State,
} from '@stencil/core';
import { MessageDoc } from '@og-shared/types';

import { firestoreListenToMessages } from '../../../services/firestore/conversations';
import { openMessenger } from '../../../services/messaging';
import { snoozeChat } from '../../../store/ui.store';
import { translate } from '../../../global/translate';
import { OgChatBubble } from '../../shared/chat-bubble/chat-bubble';

@Component({
  tag: 'og-chat-prompt',
  styleUrl: 'chat-prompt.scss',
})
export class ChatPrompt implements ComponentInterface {
  private unsubscribe?: () => void;

  @Prop() conversationId!: string; // from route/modal;
  @Prop() unreadMessages!: number;

  @State() mostRecentMessages?: MessageDoc[];

  async componentWillLoad() {
    await this.getChats();
  }

  disconnectedCallback() {
    this.unsubscribe?.();
  }

  private getChats() {
    this.unsubscribe?.();
    return new Promise(resolve => {
      // should still be a listener so that we get our new messages
      this.unsubscribe = firestoreListenToMessages(
        this.conversationId,
        this.unreadMessages > 3 ? 3 : this.unreadMessages,
        chats => {
          this.mostRecentMessages = chats;
          resolve(chats);
        }
      );
    });
  }

  render() {
    return (
      <Host>
        {this.mostRecentMessages && (
          <Fragment>
            <ion-backdrop tappable={false} />
            <div class="chat-wrapper">
              <div class="snooze-wrapper">
                <ion-chip onClick={() => snoozeChat()}>
                  <ion-icon name="close" />
                  <ion-label>{translate('SNOOZE')}</ion-label>
                </ion-chip>
              </div>
              <div class="og-clickable" onClick={() => openMessenger('reply')}>
                {this.mostRecentMessages?.map(message => (
                  <OgChatBubble
                    avatarUrl="/assets/img/cory.jpg"
                    breakWords={false}
                    message={message.message}
                    myMessage={false}
                    showTimestamp={true}
                    timestamp={message.timestamp}
                  />
                ))}
              </div>
            </div>
          </Fragment>
        )}
      </Host>
    );
  }
}
